import Layout from "@/layouts/default/main"

export default {
    path: "/log",
    name: "Log",
    redirect: "/log/index",
    component: Layout,
    children: [{
        name: "LogIndex",
        path: "index",
        component: () => import("@/views/log/index")
    }]
}